import { GatewayStatus } from 'constants/gatewayStatuses';

import { GatewayCreateFormValues } from 'pages/Gateways/GatewaysCreate/types';
import { Gateway } from 'types/embedded/gateway';

export const getGatewayDuplicateFormValues = (
  gateway: Gateway,
  defaultStatusId?: string,
): GatewayCreateFormValues => {
  const isPilotStatus = gateway.status?.value === GatewayStatus.Pilot;

  return {
    name: gateway.name,
    alias: gateway.alias,
    externalAlias: gateway.externalAlias,
    status: isPilotStatus ? defaultStatusId : gateway.status?.['@id'],
    deactivationReason: gateway.deactivationReason?.['@id'] ?? null,
    provider: gateway.provider?.['@id'],
    direction: gateway.direction?.['@id'],
    defaultCurrency: gateway.defaultCurrency?.['@id'],
    supportedCurrencies: gateway.supportedCurrencies?.map((currency) => currency['@id']),
    gatewayMethodsFromMethods: gateway.gatewayMethods?.map(
      (gatewayMethod) => gatewayMethod.method['@id'],
    ),
    managerVerified: gateway.managerVerified ?? false,
    requireAmount: gateway.requireAmount,
    pcidss: gateway.pcidss ?? false,
    pushApi: gateway.pushApi,
    saveCustomerMethodData: gateway.saveCustomerMethodData,
    statusRequestEnabled: gateway.statusRequestEnabled,
    orderExpirationTimeSec: gateway.orderExpirationTimeSec,
    transactionRequestMaxAttempts: gateway.transactionRequestMaxAttempts,
    attemptIntervalConfig: gateway.attemptIntervalConfig?.join(', '),
  };
};
